export default "__VITE_ASSET__BdmKkOTZ__"